import React from 'react'
import { FormattedCurrency, FormattedHTMLMessage } from '@web/walter-ui-kit'

import { GetProducts } from '@web/walter-lib/api'
import s from './s.module.css'
import { lang } from './lang'

interface Props {
    data: GetProducts
}

function PaymentDetails({ data }: Props) {
    return (
        <div className={s.wrap} data-pointer="payment_details">
            <FormattedHTMLMessage {...lang.paymentDetails} className={s.title} />
            <div className={s.divider} />
            <div className={s.middleContent}>
                <div className={s.middleRow}>
                    <FormattedHTMLMessage {...lang.issueCost} className={s.middleTitle} />
                    <span className={s.middleText}>
                        <FormattedCurrency
                            maxPrecision={2}
                            minimumFractionDigits={2}
                            value={data?.fees?.issuance?.fixed}
                            currency={data?.fees?.issuance?.currency}
                            dataPointer="fixed_rate_to_amount"
                        />
                    </span>
                </div>
                <div className={s.middleRow}>
                    <FormattedHTMLMessage {...lang.total} className={s.middleTitlePrimary} />
                    <span className={s.middleText}>
                        <FormattedCurrency
                            maxPrecision={2}
                            minimumFractionDigits={2}
                            value={data?.fees?.issuance?.fixed}
                            currency={data?.fees?.issuance?.currency}
                            dataPointer="fixed_rate_to_amount"
                        />
                    </span>
                </div>
            </div>
        </div>
    )
}

export default PaymentDetails
